import HomeLayout from 'components/Layout/Home';
import OneTapScript from 'components/OneTapScript';
import SplashElement from 'components/SplashElement';
import { useUserAuthDialog } from 'components/UserAuthDialog';
import { useAppContext } from 'context/AppContext';
import { useUser } from 'hooks';

import Explore from './components/Explore';
import Hero from './components/Hero';
import HowToUse from './components/HowToUse';
import InlineFAAS from './components/InlineFAAS';
import LatestInsights from './components/LatestInsights';
import OrganizationLD from './components/OrganizationLD';
import SoftwareCategories from './components/SoftwareCategories';
import VideoExplainer from './components/VideoExplainer';
import WebSiteLD from './components/WebSiteLD';

/** @type {import("./types").default} */
const Home = ({ posts, homeContent, popularCategories, popularCategory }) => {
  const { isForcingOpenLoginModal } = useAppContext();
  const [user] = useUser();

  const { categoryHubsCarousel } = homeContent;

  const [UserAuthDialog] = useUserAuthDialog({
    origin: 'header',
    openByDefault: isForcingOpenLoginModal,
  });

  return (
    <>
      <SplashElement />
      <OneTapScript user={user} />
      <UserAuthDialog />
      <OrganizationLD />
      <WebSiteLD />
      <Hero />
      <Explore popularCategory={popularCategory} />
      <HowToUse />
      <VideoExplainer />
      <InlineFAAS />
      <LatestInsights posts={posts} hubsCarousel={categoryHubsCarousel} />
      <SoftwareCategories categories={popularCategories} />
    </>
  );
};

Home.Layout = HomeLayout;

export default Home;
